module.exports = __webpack_public_path__ + "static/media/iconCanvas08.a5a88903.svg";